// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination-module--pagination--3A-mo","button":"pagination-module--button--PAASY","disabled":"pagination-module--disabled--1N0Z8"};